export default __webpack_public_path__ + "static/media/featureLeaves.1bbdbdc6.png";